
import instancesPro from '../instanceKey/instances_pro.json';
import instancesPre from '../instanceKey/instances_pre.json';

const getInstanceKey = async ( domain ) => {  
    let domainEnv = `${process.env.REACT_APP_ROOT}`;
    if (domainEnv.includes("pru-api.qdea.eus") || domainEnv.includes("pre-api.qdea.eus") || domainEnv.includes("udala-zabaltzen.api")) {
        return instancesPre[domain];
    } else {
        return instancesPro[domain];
    }
}

export default getInstanceKey

/*
import { fileURLToPath } from 'url';
import { readFile } from 'fs/promises';

const __filename = fileURLToPath(import.meta.url);
const __dirname = path.dirname(__filename);

const getInstanceKey = async (domain) => {
const filePath = path.resolve(__dirname, '../instanceKey/instances.json');
const fileContent = await readFile(filePath, 'utf-8');
const instances = JSON.parse(fileContent);
return instances[domain];
};

export default getInstanceKey;

OTRA PRUEBA
    let inst = fetch(instanceUrl)
    .then((response) => {
        if (!response.ok) {
            throw new Error('Error al cargar el archivo JSON');
        }
        return response.json();
    })
    .then((json) => setData(json))
    .catch((error) => console.error('Error:', error));

*/
